import { MutationTree } from 'vuex'
import { AppState } from './types'
import { SET_IS_LOADING, SET_USER_AGENT } from './constant'

export const mutations: MutationTree<AppState> = {
  [SET_IS_LOADING](state, isLoading: boolean) {
    state.isLoading = isLoading
  },
  [SET_USER_AGENT](state, value: string) {
    state.userAgent = value
  }
}
